import {Language} from './types'

/**
 * The default language for the application.
 */
export const globalDefaultLanguage = new Language('en', 'US', 'English', 'American English')
